/**
 * AccountsAPI
 *
 * Contact: support-ucc@cardcenter.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AccountsCollection } from '../model/accountsCollection';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class AccountsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Returns a list of accounts for the calling user or specified accounts based on provided account IDs or account reference numbers.
     * Returns a list of accounts for the calling user and the essential information for an overview page. If account IDs or account reference numbers are provided, the service will return the corresponding accounts regardless of the calling user context. All accounts are liable accounts for one or more attached credit cards.
     * @param uCCCorrelationId identifier used for correlating requests
     * @param include Comma separated list of included content. Options are  - \&#39;cards\&#39;, card information otherwise available in cards API links  is included as _embedded content. Performance of call is better if  card information is not included.  - \&#39;reservedTransactionsSummary\&#39;; determines whether reserved transaction summary is to be included in attribute reservedTransactionsSummary  or not.  - \&#39;restrictedRegistrationContext\&#39;; determines whether  restrictedRegistrationContext summary is to be  included in attribute restrictedRegistrationContext or not. - \&#39;topAccountSummary\&#39;; determines whether the aggregated balances is provided              in the top level account.
     * @param accountIds Comma separated list of account IDs. This parameter allows for the retrieval of specific accounts based on the provided account IDs. The amount is limited to 1000 entries.
     * @param accountReferenceNumbers Comma separated list of account reference numbers. This parameter allows for the retrieval of specific accounts based on the provided account reference numbers. The amount is limited to 1000 entries.
     * @param externalId Reference to client registration information stored at UCC. Only applied if issuer uses UCC registration services.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAccounts(uCCCorrelationId?: string, include?: Array<string>, accountIds?: Array<string>, accountReferenceNumbers?: Array<string>, externalId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<AccountsCollection>;
    public getAccounts(uCCCorrelationId?: string, include?: Array<string>, accountIds?: Array<string>, accountReferenceNumbers?: Array<string>, externalId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<AccountsCollection>>;
    public getAccounts(uCCCorrelationId?: string, include?: Array<string>, accountIds?: Array<string>, accountReferenceNumbers?: Array<string>, externalId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<AccountsCollection>>;
    public getAccounts(uCCCorrelationId?: string, include?: Array<string>, accountIds?: Array<string>, accountReferenceNumbers?: Array<string>, externalId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (include) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...include].join(COLLECTION_FORMATS['csv']), 'include');
        }
        if (accountIds) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...accountIds].join(COLLECTION_FORMATS['csv']), 'accountIds');
        }
        if (accountReferenceNumbers) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...accountReferenceNumbers].join(COLLECTION_FORMATS['csv']), 'accountReferenceNumbers');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>externalId, 'externalId');

        let localVarHeaders = this.defaultHeaders;
        if (uCCCorrelationId !== undefined && uCCCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('UCC-Correlation-Id', String(uCCCorrelationId));
        }

        // authentication (UserRead) required
        localVarHeaders = this.configuration.addCredentialToHeaders('UserRead', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/accounts`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AccountsCollection>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
